import { useContext, useEffect, useState } from 'react';
import useSmartState from '../../../common/hooks/useSmartState';
import FormBuilder from '../../../library/Builders/FormBuilder';
import { SmartContext } from '../../../library/Core/SmartContext';
import { getFuzzySearchCriteria, isEmpty } from '../../../library/Core/SmartFunctions';
import { FormSection } from '../../../library/Core/SmartTypes';
import FactLoader from '../../../library/SimpleControls/FactLoader';
import FiltersApplied from '../../../library/SimpleControls/FiltersApplied';
import BasAdminReportService from './BasAdminReportService';

export const SearchCriteria = () => {
    const { state, dispatch } = useContext(SmartContext);
    const { setStateValue } = useSmartState();
    const searchFormConfig = state.formConfig?.sectionRepository[0] as FormSection;
    const [isExpanded, setIsExpanded] = useState(true);
    const [fuzzySearchText, setFuzzySearchText] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let isActive = true;
        setLoading(true);

        BasAdminReportService.search(state.data.searchCriteria, state.routeInfo.pageName)
            .then((response: any) => {
                if (!isActive) return;
                setStateValue('alumniList', response.data);
                fetchAlumniCount(state);
            })
            .catch((error: any) => {
                console.error('Search API Error', error);
            })
            .finally(() => {
                if (isActive) setLoading(false);
            });

        return () => {
            isActive = false;
        };
    }, [state.data.searchCriteria]);

    
     const handleFuzzySearch = (event: any) => {
        event.preventDefault();
        const currentSearchCriteria = state.data.searchCriteria;

        const mergedSearchCriteria = {
            ...currentSearchCriteria,
            ...getFuzzySearchCriteria(fuzzySearchText) 
        };

        BasAdminReportService.search(mergedSearchCriteria, state.routeInfo.pageName).then((response: any) => {
            setStateValue('alumniList', response.data);
            const fetchAlumniCount = async () => {
                try {
                    const alumniCountData = await BasAdminReportService.searchCount(mergedSearchCriteria, state.routeInfo.pageName);
                                    
                    dispatch({
                        type: 'SET_INTERNAL_STATE',
                        payload: { key:"basCount", value:alumniCountData?.data },
                    });
                } catch (error) {
                    console.error("Error fetching alumni count:", error);
                }
            };
        
            fetchAlumniCount();
        });
    };

    const handleClearAll = () => {
        const defaultCriteria = BasAdminReportService.getDefaultSearchCriteria(state.routeInfo.pageName);

        defaultCriteria.lastCallStatusCode = "";
        defaultCriteria.accountStatusCode = "";
        defaultCriteria.profileCompletionStatusCode = "";
        defaultCriteria.isPrestigiousCollege = "";
        defaultCriteria.isPrestigiousUniversity="";
        defaultCriteria.schoolClientStatusCode = "";
        defaultCriteria.testProfileStatusCode = "";
        defaultCriteria.isValidCollegeCode = "";
        defaultCriteria.isValidCourseCode = "";
        defaultCriteria.schoolGroupId = "";
        
        defaultCriteria.pairingWithSimilarAlumni = "";
        defaultCriteria.networkForSocialCausesVolunteer = "";
        defaultCriteria.networkForBusinessIdeasAndPartnerships = "";
        defaultCriteria.networkSamePgCourseAlumni = "";
        defaultCriteria.jobAndInternships = "";
        defaultCriteria.eventsInterestedInUpskilling = "";
        defaultCriteria.eventsInterestedInEntrepreneurship = "";
        defaultCriteria.hasHigherStudies = "";

        defaultCriteria.collegeTypeCodeJson = "";
        defaultCriteria.examTypeCodeJson = "";
        defaultCriteria.presentEducationStatusCode = "";
        defaultCriteria.ispeerReviewed="";

        document.querySelectorAll('.css-1dimb5e-singleValue').forEach(element => {
            element.textContent = ''; 
        }); //universityId text not removed after clear

        if(state.routeInfo.pageName === "internal-admin-user-entered-college") defaultCriteria.isNonStandardCollege = 1;
        if(state.routeInfo.pageName === "internal-admin-user-entered-exam") defaultCriteria.isNonStandardExam = 1;

        
        setStateValue('searchCriteria', defaultCriteria);
    };

    const fetchAlumniCount = async (state:any) => {
        try {
            const basCountData = await BasAdminReportService.searchCount(state.data.searchCriteria, state.routeInfo.pageName);
            await new Promise(resolve => setTimeout(resolve, 200));
            dispatch({
                type: 'SET_INTERNAL_STATE',
                payload: { key:"basCount", value:basCountData?.data },
            });
        } catch (error) {
            console.error("Error fetching alumni count:", error);
        }
    }

    return (
        <>
            <FactLoader show={loading} />
            <div className="d-flex flex-wrap justify-content-between align-items-start align-items-md-center mb-2 filterSearch">
                <div className="d-flex flex-wrap flex-1 mb-0 justify-content-start">
                    <button className="btn-grpfiter me-3" onClick={() => setIsExpanded(!isExpanded)}>
                        <i className="icon-filter font-13 me-2"></i>
                        Filters
                    </button>
                    <div className="search alumniSearch m-0 open position-static flex-1 mb-2 me-2">
                        <form className="form-inline d-flex flex-wrap justify-content-between d-block" onSubmit={handleFuzzySearch}>
                            <input
                                value={fuzzySearchText}
                                placeholder="Search by Student/Parent Name, Email, Mobile, or User ID"
                                aria-label="Search"
                                className="form-control flex-1 font-13 font-500 text-truncate"
                                onChange={(event) => setFuzzySearchText(event?.target.value)}
                            />
                            <button className="btn btn-search icon icon-search"></button>
                        </form>
                        {/* <a href="" className="btn-search-toggle icon-search"></a> */}
                    </div>
                    {isExpanded && (
                        <div className="col-12 fitergroup p-3 bg-body-secondary">
                            <FormBuilder key="searchCriteria" section={searchFormConfig} dataKey="searchCriteria" />
                        </div>
                    )}
                </div>
            </div>

            <div className="filterresult">
                <FiltersApplied dataKey="searchCriteria" onClearAll={handleClearAll} />
            </div>
        </>
    );
};
